import {
  Box,
  Button,
  Typography
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import { Organization } from '../../types';
import OrganizationListControl from './OrganizationListControl';
import React from 'react';
import useAuth from '../../hooks/useAuth';

interface OrganizationListProps {
}

const OrganizationList: React.FC<OrganizationListProps> = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const onOrganizationEdit = async (organization: Organization) => {
    navigate(`/organizations/edit/${organization.id}`);
  };

  const onOrganizationDelete = async (organization: Organization) => {
    // Optional: Add any additional logic for deletion notification
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Organization List</Typography>
        {user?.permissions?.manage_organizations && (
          <Box>
            <Button component={Link} to="/organizations/new" variant="contained" color="primary">
              New Organization
            </Button>
          </Box>
        )}
      </Box>
      <OrganizationListControl onEdit={onOrganizationEdit} onDelete={onOrganizationDelete} />
    </Box>
  );
}

export default OrganizationList;
